import moment from 'moment'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['versao']),
  },
  methods: {
    parseDate: (date) => {
      if (!date) return null

      const [day, month, year] = date.split('/')
      var result = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

      if (result === '1899/12/30') {
        return ''
      } else {
        return result
      }
    },
    formatDiaMesAno (date) {
      if (!date) return null

      date = date.substr(0, 10)
      // console.log(date)

      const [year, month, day] = date.split('-')
      var result = `${day}/${month}/${year}`

      if (result === '30/12/1899') {
          return ''
      } else {
          return result
      }
    },
    formatDate (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${year}`
    },
    formatDateTime (date) {
      if (date) {
        date = moment(date, ' YYYY-MM-DD HH:MM:SS').format('DD/MM/YYYY HH:MM:SS')
        return date
      }
    },
    parseMoeda (valor, casasdecimais) {
      if (!valor || valor === 0) {
        return '0,00'
      } else {
        valor = valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: casasdecimais })
        return valor
      }
    },
    parseInteiro (valor) {
      if (!valor || valor === 0) {
        return '0'
      } else {
        valor = valor.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        return valor
      }
    },
    getFirstDayOfMonth (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${year}-${month}-01`
    },
    formatDateHours (Value, formato) {
      if (Value) {
        Value = moment(Value, ' YYYY-MM-DD HH:MM:SS').format(formato)
        return Value
      }
    },
    pad (number) {
      if (number < 10) {
        return '0' + number
      }
      return number
    },
    formatedDate (date, formatoSaida) {
      var newDate = moment.utc(date).format(formatoSaida.toString())
      return newDate
    },
    carregaInfoSistemaOperacional () {
      if (navigator.appVersion.indexOf('Win') !== -1) localStorage.osname = 'Windows'
      if (navigator.appVersion.indexOf('Mac') !== -1) localStorage.osname = 'MacOS'
      if (navigator.appVersion.indexOf('X11') !== -1) localStorage.osname = 'UNIX'
      if (navigator.appVersion.indexOf('Linux') !== -1) localStorage.osname = 'Linux'
      console.log(navigator.appVersion)
      console.log(localStorage.osname)
    },

    verificaVersao (versaoapi) {
      // eslint-disable-next-line eqeqeq
      if (versaoapi != this.versao) {
        // alert('aqui')
        localStorage.setItem('versao', versaoapi)
        this.$store.commit('VERSAO', versaoapi)
        this.$router.go()
      }
    },
    checkDevice () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      ) {
        return true // está utilizando celular
      } else {
        return false // não é celular
      }
    },
    formatarCasasDecimais (numero, casasDecimais) {
      const numeroFormatado = numero.toFixed(casasDecimais)
      return numeroFormatado
    },
  },
}
